import React, { Component } from "react"
import ParkingListElement from "./parkingListElement"
import ParkingCurrentBookingElement from "./parkingCurrentBookingElement"
import config from "react-global-configuration"
import * as tracking from "../../helpers/tracking"
import * as cookieNames from "../../constants/Cookies"
import * as cookieHelper from "../../../helpers/cookie"
import Spinner from "../spinner"

class ParkingList extends Component {
  static defaultProps = {
    autoSearch: true,
  }

  constructor(props) {
    super(props)

    this.state = {
      isActive: true,
      isTracked: false,
    }
  }

  componentDidMount() {
    const { arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode, changeFromBookingGuid } = this.props
    if (this.props.bookingResults) this.props.removeBooking()
    if (!this.props.allProducts || this.props.allProducts.length === 0) {
      if (!changeFromBookingGuid) {
        this.props.performParkingSearch(arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode, true)
      }
    }
    if (!this.state.isTracked && !this.props.cookies.get(cookieNames.ACCESS_TOKEN)) {
      tracking.trackPageView(
        this.props,
        "parking booking",
        "/virtual/(|en/|sv/)parkering/search" + `${this.props.useNewDesign ? "?newDesign=true" : ""}`,
      )
      this.setState({ isTracked: true })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      autoSearch,
      arrivalDate,
      arrivalTime,
      departureDate,
      departureTime,
      voucher,
      affiliateCode,
      changeFromBooking,
      ammendmentReference,
      ammendmentEmail,
    } = this.props

    const bookingChanged =
      prevProps.autoSearch !== autoSearch ||
      (!prevProps.changeFromBooking && changeFromBooking) ||
      (prevProps.changeFromBooking && changeFromBooking && prevProps.changeFromBooking.bguid !== changeFromBooking.bguid)

    if (bookingChanged && autoSearch) {
      this.props.performChangeBookingSearch(
        changeFromBooking,
        arrivalDate,
        arrivalTime,
        departureDate,
        departureTime,
        voucher,
        affiliateCode,
        ammendmentReference,
        ammendmentEmail,
        true,
      )
    }

    if (!this.state.isTracked && this.props.userAccountDetails) {
      tracking.trackPageView(
        this.props,
        "parking booking",
        "/virtual/(|en/|sv/)parkering/search" + `${this.props.useNewDesign ? "?newDesign=true" : ""}`,
      )
      this.setState({ isTracked: true })
    }
  }

  trackSorting = (sortingKey) => {
    const parkingList = config.get("textKeys.parkingList")
    if (parkingList) {
      const sorting = parkingList.sorting
      const selectedSorting = sorting.options.find((option) => option.displayName === sortingKey)
      const userId = cookieHelper.getUserId(this.props)
      const data = {
        event: "track-event",
        eventCategory: "parking flow",
        eventAction: "product sort",
        eventLabel: selectedSorting.displayName,
        eventValue: 0,
        eventNoninteraction: true,
        userParkingArrivalDate: this.props.arrivalDate,
        userParkingDepartureDate: this.props.departureDate,
        pageBusinessunit: "parking",
        logged_in: cookieHelper.isLoggedIn(),
      }
      if (userId) data.userId = userId
      window.dataLayer.push(data)
    }
  }

  handleSortingSelection = (event) => {
    const { changeFromBooking, isAmendment } = this.props
    if (changeFromBooking) {
      const sortingKey = event.target.selectedOptions[0].value
      this.trackSorting(event.target.selectedOptions[0].innerText)
      this.props.handleSorting(sortingKey, changeFromBooking, isAmendment)
    } else {
      const sortingKey = event.target.selectedOptions[0].value
      this.trackSorting(event.target.selectedOptions[0].innerText)
      this.props.handleSorting(sortingKey)
    }
  }

  renderSortingOption(displayName, sortingKey) {
    return (
      <option value={sortingKey} key={sortingKey}>
        {displayName}
      </option>
    )
  }
  render() {
    const { allProducts, focusOnContextBooking } = this.props
    if (allProducts.length === 0) return null

    const isTimeChangeOnly = allProducts.length === 1

    const parkingList = config.get("textKeys.parkingList") || {}
    const sorting = parkingList.sorting || {}
    let sortingOptions = sorting.options.filter((x) => x.sortingKey !== "upgradeOption") // upgradeOption er en dedikeret amendmentflow option.
    let amendmentSorting = sorting.options

    let displayProducts = [...allProducts]
    let contextBookingNotAvailable = false
    if (focusOnContextBooking && this.props.changeFromBooking) {
      //    displayProducts = displayProducts.filter(item => item?.carPark?.name === this.props.changeFromBooking?.carPark?.name)
      displayProducts = displayProducts.filter((item) => item.product.id === this.props.changeFromBooking.booking.productId)
      if (displayProducts.length === 0) {
        contextBookingNotAvailable = true
        displayProducts = [...allProducts]
      }
    }
    return (
      <section className="deck deck--white">
        <Spinner isActive={this.props.ajaxSpinnerActive} isTransparent={this.props.ajaxSpinnerTransparent} />
        {/* <div className={`parking-product-table js--accordion rich-text ${this.state.isActive ? "is-active" : "is-bound"}`} data-disposable="true"> */}
        {/* {!this.state.isActive ?
            <button className="parking-product-table__trigger button button--medium button--discreet js--accordion-trigger"
              onClick={() => { this.setState({ isActive: true }) }}
            >
              <span className="text">{parkingList.showMore || "Se alle pladser"}</span>
            </button>
            : ''} */}
        <div className="parking-product-table">
          <div className="parking-product-table__topbar w--wider">
            {contextBookingNotAvailable ? (
              <header className="parking-product-table__topbar__header">
                <h3>
                  {this.props.changeFromBooking.carPark.name}{" "}
                  {parkingList.contextBookingNotAvailableWarning || "er ikke ledig i den ønskede periode. Vælg et andet P-anlæg"}
                </h3>
              </header>
            ) : (
              ""
            )}
            {!isTimeChangeOnly ? (
              <div className="parking-product-table__topbar__sorting">
                <div className="form">
                  <div className="form__section form__section--light">
                    <div className="form__field form__field--select  is-filled">
                      <div className="form__container">
                        <span className="form__valid" />
                        <select
                          id="select"
                          className="form__item "
                          aria-label="Select menu"
                          tabIndex="1"
                          onChange={(event) => this.handleSortingSelection(event)}
                        >
                          {this.props.isAmendment //amendment options
                            ? amendmentSorting && amendmentSorting.map((sort) => this.renderSortingOption(sort.displayName, sort.sortingKey)) //regular options
                            : sortingOptions && sortingOptions.map((sort) => this.renderSortingOption(sort.displayName, sort.sortingKey))}
                        </select>
                        <label htmlFor="select" className="form__label">
                          <span className="form__label__text">
                            {sorting.title || "Dato"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          {this.props.isAmendment ? (
            <ParkingCurrentBookingElement
              isFirstBooking={true}
              changeFromBooking={this.props.changeFromBooking}
              priceFormatter={this.props.priceFormatter}
            />
          ) : null}
          <div className="parking-product-table__list">
            {/* map parkings */}
            {displayProducts.map((item, index) => (
              <ParkingListElement
                isAmendment={this.props.isAmendment}
                item={item}
                key={item.product.id}
                gaListIndex={index + 1}
                gaList={`Choose Space | ${item.product.categoryName} List`}
                {...this.props}
                globals={this.props.globals}
              />
            ))}
          </div>
        </div>
      </section>
    )
  }
}

export default ParkingList
